import { FlowRoutes } from '../../globalTypes';
var SearchFlowHelper = /** @class */ (function () {
    function SearchFlowHelper() {
    }
    SearchFlowHelper.isSearchFlow = function (url) {
        var searchFlowRegex = '.*?[\\w.-]*\\.[\\w]*\\/[\\w-]*\\/([\\w.-]*)';
        var matching = url.match(searchFlowRegex);
        var flow = (matching && matching.length > 1) ? matching : null;
        if (matching == null) {
            return false;
        }
        for (var i = 0; i < matching.length; i += 1) {
            if (matching[i] in FlowRoutes) {
                return true;
            }
        }
        return false;
    };
    return SearchFlowHelper;
}());
export { SearchFlowHelper };
export default SearchFlowHelper;
